// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.low-evaluate .ant-progress-text-end,
.ant-progress-text {
  color: #4CAF50 !important;
}

.high-evaluate .ant-progress-text-end,
.ant-progress-text {
  color: #FF9933 !important;
}

.bad-evaluate .ant-progress-text-end,
.ant-progress-text {
  color: #FF4D4F !important;
}

.activity-wrapper {
  position: absolute;
  width: -webkit-fill-available;
}

.custom-scrollbar {
  scrollbar-width: thin;
  scrollbar-color: #008BB7 #e5e7eb;
}

.custom-scrollbar::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.custom-scrollbar::-webkit-scrollbar-track {
  background: #e5e7eb;
  border-radius: 4px;
}

.custom-scrollbar::-webkit-scrollbar-thumb {
  background-color: #008BB7;
  border-radius: 4px;
}

.long-title {
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 277px;
}`, "",{"version":3,"sources":["webpack://./src/features/student/report/index.css"],"names":[],"mappings":"AAAA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB","sourcesContent":[".low-evaluate .ant-progress-text-end,\n.ant-progress-text {\n  color: #4CAF50 !important;\n}\n\n.high-evaluate .ant-progress-text-end,\n.ant-progress-text {\n  color: #FF9933 !important;\n}\n\n.bad-evaluate .ant-progress-text-end,\n.ant-progress-text {\n  color: #FF4D4F !important;\n}\n\n.activity-wrapper {\n  position: absolute;\n  width: -webkit-fill-available;\n}\n\n.custom-scrollbar {\n  scrollbar-width: thin;\n  scrollbar-color: #008BB7 #e5e7eb;\n}\n\n.custom-scrollbar::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n\n.custom-scrollbar::-webkit-scrollbar-track {\n  background: #e5e7eb;\n  border-radius: 4px;\n}\n\n.custom-scrollbar::-webkit-scrollbar-thumb {\n  background-color: #008BB7;\n  border-radius: 4px;\n}\n\n.long-title {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 277px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
